module.exports = __webpack_public_path__ + "static/icons/generic.e362cb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payments/generic.png
// module id = apex
// module chunks = 1